<template>
  <svg
    width="110"
    height="109"
    viewBox="0 0 110 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Orion_take-a-photo">
      <path
        id="layer2"
        d="M55 105.594C83.2183 105.594 106.094 82.7183 106.094 54.5C106.094 26.2817 83.2183 3.40625 55 3.40625C26.7817 3.40625 3.90625 26.2817 3.90625 54.5C3.90625 82.7183 26.7817 105.594 55 105.594Z"
        stroke="currentColor"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M82.5906 37.4688H69.8172L63.175 30.6562H46.825L40.1828 37.4688H27.4094C26.5963 37.4688 25.8166 37.7917 25.2417 38.3667C24.6667 38.9416 24.3438 39.7213 24.3438 40.5344V71.8719C24.3438 72.6849 24.6667 73.4647 25.2417 74.0396C25.8166 74.6145 26.5963 74.9375 27.4094 74.9375H82.5906C83.4037 74.9375 84.1834 74.6145 84.7584 74.0396C85.3333 73.4647 85.6562 72.6849 85.6562 71.8719V40.5344C85.6562 39.7213 85.3333 38.9416 84.7584 38.3667C84.1834 37.7917 83.4037 37.4688 82.5906 37.4688Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <circle
        id="Ellipse 13"
        cx="55"
        cy="54.5"
        r="9.21875"
        fill="white"
        stroke="currentColor"
        stroke-width="2"
      />
    </g>
  </svg>
</template>
